//changed due to package upgrade
import React, { useEffect, useState } from 'react';
import AppScrollbar from '@projectK/components/AppScrollbar';
import PropTypes from 'prop-types';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import {
  Box,
  Typography,
  Divider,
  Modal,
  IconButton,
  Grid,
  Autocomplete,
  TextField,
  alpha,
  FormControl,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import AppCard from '@projectK/components/AppCard';
import AppLoader from '@projectK/components/AppLoader';
import { useInfoViewActionsContext } from '@projectK/context';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import jwtAxios from '@projectK/services/auth/JWT';
import { Field, Form, Formik } from 'formik';
import { CloseRounded } from '@mui/icons-material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import IntlMessages from '@projectK/helpers/IntlMessages';
import AppTextField from '@projectK/components/AppTextField';
import * as yup from 'yup';
import AddCredits from './AddCredits';
import { OnwerRoles } from '@projectK/constants';
import { MyProductsMain } from '@projectK/MainComponents';
import AppModalConfirmation from '@projectK/components/AppModalConfirmation';
import {
  isParent,
  isActualSuperAdmin,
  isActualAdmin,
} from '@projectK/context/RolesProvider';
import productIcon from '../../../../../../../apps/admin/src/assets/icon/products.svg';

const customScrollbarStyle = {
  WebkitScrollbar: {
    width: '12px',
  },
  WebkitScrollbarThumb: {
    backgroundColor: '#888',
  },
  WebkitScrollbarThumbHover: {
    backgroundColor: '#555',
  },
};

const MyProducts = ({
  settings,
  loading,
  setLoading,
  fetchUserProduct,
  fetchMySchedule,
  fetchActivitySessions,
  fetchWaitList,
  isModalOpen,
  setIsModalOpen,
  openModal,
  openAdjustCreditsModal,
  isAdjustCreditsModalOpen,
  setIsAdjustCreditsModalOpen,
  showDashboard,
}) => { //NOSONAR
  const { isMobile } = useMobileSettings();
  const companyTheme = CompanyTheme();
  const navigate = useNavigate();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProductOption, setSelectedProductOption] = useState('');
  const [selectedCreditOption, setSelectedCreditOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [parentMemberData, setParentMemberData] = useState([]);
  const [selectedUserOption, setSelectedUserOption] = useState('');
  const { user } = useAuthUser();
  const [openDialog, setOpenDialog] = useState(false);
  const verbiageData =
    JSON.parse(localStorage.getItem('verbiageSettings')) || {};

  const closeAdjustCreditsModal = () => {
    setIsAdjustCreditsModalOpen(false);
  };

  const primaryColor = companyTheme ? companyTheme.primary.main : '#2196f3';
  const priColor = companyTheme ? companyTheme.primary.main : 'primary';
  const textColor = companyTheme ? companyTheme.primary.main : 'text.primary';

  const closeModal = () => {
    setIsModalOpen(false);
    setIsChecked(false);
    setSelectedProductOption('');
    setSelectedUserOption('');
    setPurchaseOptions([]);
  };
  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    closeModal();
  };
  useEffect(() => {
    fetchProductData();
  }, []);

  const fetchProductData = async () => {
    try {
      const response = await jwtAxios.get(`/products`, {
        params: {
          perPage: 'all',
        },
      });
      const { data } = response;
      setProductOptions(data?.list);
    } catch (error) {
      setProductOptions([]);
    }
  };

  const [purchaseOptions, setPurchaseOptions] = useState([]);

  const fetchPurchaseOptions = async (selectedProductOptionId) => {
    try {
      const response =
        selectedProductOptionId &&
        (await jwtAxios.get(
          `/product-purchase-options/${selectedProductOptionId}`,
        ));
      const purchaseOptionsArray = response?.data?.list || [];
      setPurchaseOptions(purchaseOptionsArray);
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [productId, setProductId] = useState(null);
  const handleDelete = (product_Id, itemId) => {
    setProductId(product_Id);
    setItemToDelete(itemId);
    setDeleteConfirmationOpen(true);
  };
  const handleConfirmDelete = () => {
    setDeleteConfirmationOpen(false);
    setLoading(true);
    jwtAxios
      .delete(`/product-members/${productId}/${itemToDelete}`)
      .then((response) => {
        if (Array.isArray(productOptions)) {
          setProductOptions(
            productOptions.filter((item) => item?.id !== itemToDelete),
          );
        }
        fetchUserProduct();
        if (!isMobile) {
          fetchMySchedule();
          fetchWaitList();
          fetchActivitySessions();
        }
        setLoading(false);
        infoViewActionsContext.showMessage('Product deleted successfully!');
      })
      .catch((error) => {
        infoViewActionsContext.fetchError('Error deleting Product Member.');
        console.error('Error deleting Product Member:', error);
      });
  };
  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };
  useEffect(() => {
    fetchMembersData();
  }, []);

  const fetchMembersData = async () => {
    try {
      const response = await jwtAxios.get(`/user-members/${user?.id}`, {
        params: {
          perPage: 5,
        },
      });
      const { data } = response;
      setParentMemberData(data?.list);
    } catch (error) {
      setParentMemberData([]);
    }
  };

  let myProductsCard;

  if (loading) {
    myProductsCard = <AppLoader />;
  } else if (settings?.length === 0) {
    myProductsCard = (
      <Box
        className='no-product-list'
        sx={{
          textAlign: 'center',
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
        }}
      >
        <Typography variant='body1' sx={{ fontWeight: 'bold', fontSize: 18 }}>
          No products found
        </Typography>
      </Box>
    );
  } else {
    myProductsCard = (
      <div
        className={isMobile ? 'mobile-product product-list' : 'product-list'}
      >
        <MyProductsMain
          settings={settings}
          user={user}
          OnwerRoles={OnwerRoles}
          navigate={navigate}
          handleDelete={handleDelete}
          showDashboard={showDashboard}
        />
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCancelDelete}
          maxWidth='xs'
        >
          <DialogTitle>
            <Typography variant='h4'>Confirm Deletion</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
              Are you sure you want to delete this product?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDelete} color='primary'>
              Yes
            </Button>
            <Button onClick={handleCancelDelete} color='secondary'>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  let productBgCard = (
    <>
      {showDashboard !== true && (
        <>
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {isMobile ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  margin: 2,
                }}
              >
                <img src={productIcon} alt='products' width={28} height={28} />
                <Typography variant='h4' color='primary' sx={{ margin: 1 }}>
                  {verbiageData?.product_type || 'Products'}
                </Typography>
              </Box>
            ) : (
              <Typography variant='h4' sx={{ color: textColor, margin: 0 }}>
                {verbiageData?.product_type || 'Products'}
              </Typography>
            )}

            <Box display='flex' flexDirection='row' alignItems='center'>
              {(isActualSuperAdmin(user) || isActualAdmin(user)) && (
                <Button
                  variant='outlined'
                  sx={{
                    ml: 1.5,
                    borderColor: primaryColor,
                    '&:hover': {
                      borderColor: alpha(primaryColor, 0.8),
                    },
                    color: priColor,
                  }}
                  onClick={openAdjustCreditsModal}
                >
                  Adjust Credits
                </Button>
              )}
              {isActualSuperAdmin(user) || isActualAdmin(user) ? (
                <Button
                  variant='outlined'
                  sx={{
                    ml: 1.5,
                    borderColor: primaryColor,
                    '&:hover': {
                      borderColor: alpha(primaryColor, 0.8),
                    },
                    color: priColor,
                  }}
                  onClick={openModal}
                >
                  Add {verbiageData?.product_type || 'Product'}
                </Button>
              ) : (
                ''
              )}
            </Box>
          </Grid>
          <Divider sx={{ my: 2 }} />
        </>
      )}

      {isMobile ? (
        myProductsCard
      ) : (
        <AppScrollbar className='scroll-products'>
          {myProductsCard}
        </AppScrollbar>
      )}
    </>
  );

  return (
    <>
      {isMobile ? productBgCard : <AppCard>{productBgCard}</AppCard>}
      <Modal
        open={isModalOpen}
        onClose={handleDialogOpen}
        className='add-product-pop'
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            borderRadius: '8px',
            boxShadow: 24,
            p: 4,
            minWidth: 300,
            maxHeight: 'calc(100vh - 200px)',
            overflow: 'auto',
            ...customScrollbarStyle,
          }}
        >
          <Formik
            enableReinitialize={true}
            initialValues={{
              user_id: user?.id,
              credit_option_id: null,
              product_id: '',
              description: null,
              credit_amount: '',
              expiry_date: null,
              send_invitation: false,
              member_id: isParent(user) ? null : user?.id,
            }}
            validationSchema={yup.object({
              member_id: !selectedUserOption
                ? yup.string().required('Please choose at least one member.')
                : yup.string(),
              credit_amount: yup
                .number()
                .typeError('Please enter a valid credit amount.')
                .nullable()
                .positive('Credit amount must be a positive number.'),
            })}
            onSubmit={async (values, { setSubmitting, resetForm }) => {
              setSubmitting(true);
              const { send_invitation, credit_option_id, member_id, ...rest } =
                values;
              try {
                if (credit_option_id) {
                  await jwtAxios.post(`/product-members/${values.product_id}`, [
                    {
                      credit_option_id: credit_option_id,
                      send_invitation: send_invitation,
                      member_id: values.member_id,
                    },
                  ]);
                }
                if (isChecked) {
                  await jwtAxios.post(`/credits`, {
                    ...rest,
                    ...(isParent(user) ? { user_id: member_id } : {}),
                  });
                }
                fetchUserProduct();
                fetchMySchedule();
                if (!isMobile) {
                  fetchWaitList();
                  fetchActivitySessions();
                  setSelectedUserOption();
                }
                resetForm();
                handleCloseModalDialog();
                infoViewActionsContext.showMessage(
                  'Credit has been added successfully!',
                );
              } catch (error) {
                infoViewActionsContext.fetchError(error?.response?.data?.error);
                setSubmitting(false);
              }
            }}
          >
            {({ values, setFieldValue, touched, errors }) => (
              <Form noValidate autoComplete='off'>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box>
                    <Typography
                      variant='h4'
                      sx={{
                        color: textColor,
                      }}
                    >
                      Add {verbiageData?.product_type || 'Product'}
                    </Typography>
                  </Box>
                  <Box>
                    <IconButton
                      size='small'
                      sx={{ fontWeight: 'bold', color: '#000000' }}
                      className='icon-btn'
                      onClick={handleDialogOpen}
                    >
                      <CloseRounded />
                    </IconButton>
                  </Box>
                </Box>
                <AppGridContainer>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <Box
                      sx={{
                        border: '1px solid #EAECF0',
                        p: 6,
                        borderRadius: 3,
                        boxShadow:
                          '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)',
                      }}
                    >
                      <AppGridContainer className='product-credit'>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <Typography
                            sx={{
                              width: '100%',
                              mb: 4,
                            }}
                          >
                            Please note that members will not be charged for the
                            selected credit option.
                          </Typography>
                          <AppGridContainer>
                            {isParent(user) && (
                              <Grid size={{ xs: 12, md: 6 }}>
                                <Autocomplete
                                  sx={{
                                    width: '100%',
                                  }}
                                  options={(parentMemberData || []).sort(
                                    (a, b) =>
                                      a.first_name.localeCompare(
                                        b.first_name,
                                        undefined,
                                        {
                                          numeric: true,
                                          sensitivity: 'base',
                                        },
                                      ),
                                  )}
                                  getOptionLabel={(option) =>
                                    `${option.first_name} ${option.last_name} -${option.email}`
                                  }
                                  value={
                                    parentMemberData.find(
                                      (user) => user.id === selectedUserOption,
                                    ) || null
                                  }
                                  onChange={(event, newValue) => {
                                    const selectedUserId = newValue
                                      ? newValue.id
                                      : '';

                                    // Update local state
                                    setSelectedUserOption(selectedUserId);
                                    if (setFieldValue) {
                                      setFieldValue(
                                        'member_id',
                                        selectedUserId,
                                      );
                                      fetchPurchaseOptions(selectedUserId);
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label='Members'
                                      error={
                                        touched.member_id &&
                                        Boolean(errors.member_id)
                                      }
                                      helperText={
                                        touched.member_id && errors.member_id
                                          ? 'Please choose a member.'
                                          : ''
                                      }
                                    />
                                  )}
                                />
                              </Grid>
                            )}

                            <Grid size={{ xs: 12, md: 6 }}>
                              <Autocomplete
                                sx={{
                                  width: '100%',
                                }}
                                options={(productOptions || []).sort((a, b) =>
                                  a.product_name.localeCompare(
                                    b.product_name,
                                    undefined,
                                    {
                                      numeric: true,
                                      sensitivity: 'base',
                                    },
                                  ),
                                )}
                                getOptionLabel={(option) =>
                                  option.badge
                                    ? `${option.product_name} - ${option.badge}`
                                    : option.product_name
                                }
                                value={
                                  productOptions.find(
                                    (product) =>
                                      product.id === selectedProductOption,
                                  ) || null
                                }
                                onChange={(event, newValue) => {
                                  const selectedProductId = newValue
                                    ? newValue.id
                                    : '';

                                  // Update local state
                                  setSelectedProductOption(selectedProductId);
                                  setFieldValue('credit_option_id', null); // Reset credit option
                                  setSelectedCreditOption(null);
                                  if (setFieldValue) {
                                    setFieldValue(
                                      'product_id',
                                      selectedProductId,
                                    );
                                    fetchPurchaseOptions(selectedProductId);
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      verbiageData?.product_type || 'Products'
                                    }
                                  />
                                )}
                              />
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                              <FormControl fullWidth className='credit-option'>
                                <Autocomplete
                                  freeSolo={false}
                                  sx={{
                                    width: '100%',
                                  }}
                                  options={purchaseOptions || []}
                                  getOptionLabel={(option) =>
                                    `${option.option_label} | $${parseFloat(
                                      option.purchase_price,
                                    ).toFixed(2)} | ${
                                      option.check_here_for_unlimited_credits
                                        ? '∞'
                                        : option.credit_amount
                                    } credits`
                                  }
                                  value={
                                    purchaseOptions.find(
                                      (po) => po.id === selectedCreditOption,
                                    ) || null
                                  }
                                  onChange={(event, newValue) => {
                                    setFieldValue(
                                      'credit_option_id',
                                      newValue?.id,
                                    );
                                    setSelectedCreditOption(newValue?.id);
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      name='credit_option_id'
                                      label='Credit Option'
                                    />
                                  )}
                                />
                              </FormControl>
                            </Grid>
                            <Grid size={{ xs: 12, md: 6 }}>
                              <FormControlLabel
                                control={
                                  <Field
                                    component={Checkbox}
                                    checked={isChecked}
                                    type='checkbox'
                                    onChange={(event) => {
                                      setIsChecked(event.target.checked);
                                    }}
                                  />
                                }
                                label='Check here for custom credits'
                              />
                            </Grid>
                            {isChecked && (
                              <Grid size={{ xs: 12, md: 6 }}>
                                <AppTextField
                                  name='credit_amount'
                                  variant='outlined'
                                  sx={{
                                    width: '100%',
                                  }}
                                  label='Credit Amount'
                                />
                              </Grid>
                            )}
                          </AppGridContainer>
                        </Grid>
                        <Grid size={{ xs: 12, md: 12 }}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            {values.product_id &&
                              (values.credit_amount ||
                                values.credit_option_id) && (
                                <Button
                                  sx={{
                                    position: 'relative',
                                    minWidth: 100,
                                    backgroundColor: primaryColor,
                                    '&:hover': {
                                      backgroundColor: alpha(primaryColor, 0.8),
                                    },
                                  }}
                                  variant='contained'
                                  type='submit'
                                >
                                  <IntlMessages id='common.save' />
                                </Button>
                              )}
                            <Button
                              sx={{
                                position: 'relative',
                                minWidth: 100,
                                ml: 2.5,
                                borderColor: primaryColor,
                                '&:hover': {
                                  borderColor: alpha(primaryColor, 0.8),
                                },
                                color: primaryColor,
                              }}
                              variant='outlined'
                              onClick={handleDialogOpen}
                            >
                              <IntlMessages id='common.cancel' />
                            </Button>
                          </Box>
                        </Grid>
                      </AppGridContainer>
                    </Box>
                  </Grid>
                </AppGridContainer>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>
      <AppModalConfirmation
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        handleCloseModalDialog={handleCloseModalDialog}
      />
      {isAdjustCreditsModalOpen && (
        <AddCredits
          isOpen={isAdjustCreditsModalOpen}
          onClose={closeAdjustCreditsModal}
          isAdjustCreditsModalOpen={isAdjustCreditsModalOpen}
          settings={settings}
          fetchUserProduct={fetchUserProduct}
        />
      )}
    </>
  );
};

export default MyProducts;

MyProducts.propTypes = {
  settings: PropTypes.array,
  loading: PropTypes.bool,
  setLoading: PropTypes.func,
  fetchUserProduct: PropTypes.func,
  fetchMySchedule: PropTypes.func,
  fetchActivitySessions: PropTypes.func,
  fetchWaitList: PropTypes.func,
  isModalOpen: PropTypes.func,
  setIsModalOpen: PropTypes.func,
  openModal: PropTypes.func,
  openAdjustCreditsModal: PropTypes.func,
  isAdjustCreditsModalOpen: PropTypes.func,
  setIsAdjustCreditsModalOpen: PropTypes.func,
  showDashboard: PropTypes.func,
};
